/* eslint-disable @typescript-eslint/no-explicit-any,jsx-a11y/label-has-associated-control */
import React, { type FC } from 'react';
import type { Option } from '../../../../index';

type LabelProps = {
  name: string;
  item: Option;
  hideRadio?: boolean;
  disabled?: boolean;
  value: any;
  currentIndex: number;
  options: Option[];
  updateValue: (val: any) => void;
};

const Label: FC<LabelProps> = (props) => {
  const { name, item, hideRadio, updateValue, value, currentIndex, options, disabled } = props;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>) => {
    const keyCode = e.key;

    if (
      keyCode === 'Enter' ||
      keyCode === ' ' ||
      keyCode === 'ArrowLeft' ||
      keyCode === 'ArrowUp' ||
      keyCode === 'ArrowRight' ||
      keyCode === 'ArrowDown'
    ) {
      e.preventDefault();
      let newIndex = 0;
      let newValue = item.value;

      switch (keyCode) {
        case 'Enter':
        case ' ':
          if (disabled) break;
          updateValue(item.value);
          break;
        case 'ArrowLeft':
        case 'ArrowUp': {
          newIndex = currentIndex === 0 ? options.length - 1 : currentIndex - 1;
          newValue = options[newIndex].value;
          if (options[newIndex].disabled || disabled) break;
          updateValue(newValue);
          break;
        }
        case 'ArrowRight':
        case 'ArrowDown': {
          newIndex = currentIndex === options.length - 1 ? 0 : currentIndex + 1;
          newValue = options[newIndex].value;
          if (options[newIndex].disabled || disabled) break;
          updateValue(newValue);
          break;
        }
        default:
          break;
      }
    }
  };

  return (
    <label
      {...{
        id: `label_${name}_${item.value}`,
        htmlFor: name + item.value,
        style: item.style ? item.style : {},
        onKeyDown: (e) => handleKeyDown(e),
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
      }}
    >
      {hideRadio ? null : (
        <svg {...{ width: 24, height: 24, viewBox: '0 0 24 24' }}>
          <circle {...{ className: 'outer', cx: 12, cy: 12, r: 9, strokeWidth: 1 }} />
          {item.value === value ? <circle {...{ className: 'inner', cx: 12, cy: 12, r: 4.8 }} /> : null}
        </svg>
      )}
      {item.label}
    </label>
  );
};

export default Label;
